import { render, staticRenderFns } from "./InvoiceDetailsPopup.vue?vue&type=template&id=3610da23&scoped=true&"
import script from "./InvoiceDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsPopup.vue?vue&type=style&index=0&id=3610da23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610da23",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/InvoiceDetailsPopup.vue
// module id = null
// module chunks = 